// @flow
//Types
import type { Promotion } from '../types';

export const isMinAmountPromotionCompleted = (
  promotion: Promotion,
  currentPrice: number,
): boolean => {
  if (!promotion || !promotion.promotionRules) {
    return false;
  }

  const promotionRuleWithAmountMin = promotion.promotionRules.find(
    pr => pr?.preferences?.amountMin !== undefined,
  );

  if (!promotionRuleWithAmountMin) {
    return false;
  }

  const promotionValue = promotionRuleWithAmountMin?.preferences?.amountMin ?? 0;

  return currentPrice >= promotionValue;
};
